<template>
  <div class="propertylist">
    <div class="list">
      <div class="item" v-for="item in propertylist" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import residentList1 from "../../../../assets/product/residentList1.png";
import residentList2 from "../../../../assets/product/residentList2.png";
import residentList3 from "../../../../assets/product/residentList3.png";
import residentList4 from "../../../../assets/product/residentList4.png";

export default {
  setup() {
    return reactive({
      propertylist: [
        {
          id: 1,
          logo: residentList1,
          title: "一键开门",
        },
        {
          id: 2,
          logo: residentList2,
          title: "一键缴费",
        },
        {
          id: 3,
          logo: residentList3,
          title: "报事报修",
        },
        {
          id: 4,
          logo: residentList4,
          title: "邻里互动",
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertylist {
  width:92vw;
  margin: 24px auto 0;
}
.propertylist .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.propertylist .list .item  {
    text-align: center;
    overflow: hidden;
    margin-bottom: 16px;
}
.propertylist .list .item img {
    width: 82px;
    margin-bottom: 12px;
}
.propertylist .list .item div {
    font-size: 13px;
    color: #333;
    font-weight: 600;
}
</style>
